import React from 'react';
import Layout from './Layout';
import { Link } from 'react-router-dom'
import { getCoberturasRef, getMunicipiosZonasRef, getComunidadesDisponiblesRef } from '../firebase/firebase.utils'

const WHATSAPP_COBERTURA = 'https://wa.me/5217712438160?text=' + encodeURIComponent('Hola, quisiera saber si tienen cobertura en mi comunidad.');

// Quita acentos y mayúsculas para que la búsqueda encuentre "Tasquillo" escribiendo "tasquíllo" o "TASQ"
const normalizar = (texto = '') => texto.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();

const TECNOLOGIAS = {
    fibra: { icono: 'fas fa-network-wired', texto: 'Fibra óptica' },
    inalambrico: { icono: 'fas fa-broadcast-tower', texto: 'Inalámbrico' },
    nuevo: { icono: 'fas fa-star', texto: 'Nuevo' },
};

// Pastilla completa: solo en la leyenda, para explicar los íconos
const ChipTecnologia = ({ tipo }) => {
    const chip = TECNOLOGIAS[tipo];
    return <span className={`coberturaChip coberturaChip--${tipo}`}><i className={chip.icono}></i>{chip.texto}</span>;
};

// Versión compacta para cada comunidad: solo el ícono (el texto queda en title y para lectores de pantalla)
const IconoTecnologia = ({ tipo }) => {
    const chip = TECNOLOGIAS[tipo];
    return (
        <span className={`coberturaIcono coberturaIcono--${tipo}`} title={chip.texto}>
            <i className={chip.icono} aria-hidden="true"></i>
            <span className="sr-only">{chip.texto}</span>
        </span>
    );
};

class Cobertura extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            estados: [],
            loading: true,
            busqueda: '',
            abiertos: {},  // id de municipio -> desplegado
        }
    }

    // Firestore: comunidades/{estado}/municipiozona/{municipio}/zonas/{comunidad}
    obtenerComunidades = async () => {
        const estadosSnap = await getCoberturasRef().get();
        const estados = await Promise.all(estadosSnap.docs.map(async estado => {
            const municipiosSnap = await getMunicipiosZonasRef(estado.id).get();
            const municipioszonas = await Promise.all(municipiosSnap.docs.map(async municipio => {
                const comunidadesSnap = await getComunidadesDisponiblesRef(estado.id, municipio.id).get();
                return {
                    ...municipio.data(),
                    id: municipio.id,
                    comunidades: comunidadesSnap.docs.map(comunidad => ({ ...comunidad.data(), id: comunidad.id })),
                };
            }));
            return { ...estado.data(), id: estado.id, municipioszonas };
        }));
        this.setState({ estados, loading: false });
    }

    componentDidMount() {
        let event = new Event('js');
        window.dispatchEvent(event);
        this.obtenerComunidades().catch(error => {
            console.error(error);
            this.setState({ loading: false });
        });
    }

    toggleMunicipio = (id) => {
        this.setState(({ abiertos }) => ({ abiertos: { ...abiertos, [id]: !abiertos[id] } }));
    }

    // Con búsqueda activa se muestran solo las comunidades que coinciden (o todo el municipio si coincide su nombre)
    filtrarMunicipios = (municipios) => {
        const q = normalizar(this.state.busqueda.trim());
        if (!q) return municipios;
        return municipios
            .map(municipio => normalizar(municipio.nombreZona).includes(q)
                ? municipio
                : { ...municipio, comunidades: municipio.comunidades.filter(c => normalizar(c.nombre).includes(q)) })
            .filter(municipio => municipio.comunidades.length > 0);
    }

    renderMunicipio = (municipio) => {
        const buscando = this.state.busqueda.trim() !== '';
        const abierto = buscando || !!this.state.abiertos[municipio.id];
        const total = municipio.comunidades.length;
        const conFibra = municipio.comunidades.filter(c => c.fibra).length;
        return (
            <div className={'coberturaMunicipio' + (abierto ? ' is-abierto' : '')} key={municipio.id}>
                <button type="button" className="coberturaMunicipio-header" aria-expanded={abierto} onClick={() => this.toggleMunicipio(municipio.id)}>
                    <span className="coberturaMunicipio-icono"><i className="fas fa-city"></i></span>
                    <span className="coberturaMunicipio-nombre">
                        <b>{municipio.nombreZona}</b>
                        <span>
                            {total} {total === 1 ? 'comunidad' : 'comunidades'}
                            {conFibra > 0 && <> · {conFibra} con fibra óptica</>}
                        </span>
                    </span>
                    <span className="coberturaMunicipio-toggle"><i className="fas fa-chevron-down"></i></span>
                </button>
                {/* Siempre en el DOM para animar la altura (grid-template-rows 0fr -> 1fr) */}
                <div className="coberturaMunicipio-cuerpo" aria-hidden={!abierto}>
                    <div className="coberturaMunicipio-cuerpo-interior">
                        <ul className="coberturaMunicipio-lista">
                            {municipio.comunidades.map(comunidad => (
                                <li key={comunidad.id} className="coberturaComunidad">
                                    <span className="coberturaComunidad-nombre">
                                        {comunidad.nombre}
                                        {comunidad.nuevo && <IconoTecnologia tipo="nuevo" />}
                                    </span>
                                    <span className="coberturaComunidad-iconos">
                                        {comunidad.fibra && <IconoTecnologia tipo="fibra" />}
                                        {comunidad.wireless && <IconoTecnologia tipo="inalambrico" />}
                                    </span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const estados = this.state.estados
            .map(estado => ({ ...estado, municipioszonas: this.filtrarMunicipios(estado.municipioszonas) }))
            .filter(estado => estado.municipioszonas.length > 0);
        const sinResultados = !this.state.loading && this.state.busqueda.trim() !== '' && estados.length === 0;

        return (
            <div>
                <Layout title="Red Itmex - Cobertura">

                    <section className="coberturaHero-wrapper">
                        <div className="coberturaHero" style={{ backgroundImage: 'linear-gradient(to bottom, rgba(8, 28, 72, 0.7) 0%, rgba(8, 28, 72, 0.35) 40%, rgba(8, 28, 72, 0) 65%), url(/assets/img/backgrounds/ixmiquilpan-cobertura.jpg)' }}>
                            <div className="coberturaHero-content">
                                <span className="planesItmex-eyebrow coberturaHero-eyebrow">Cobertura</span>
                                <h1 className="heroItmex-title">Internet en tu comunidad</h1>
                                <p className="heroItmex-subtitle">Revisa dónde tenemos fibra óptica e internet inalámbrico en Hidalgo.</p>
                                <div className="heroItmex-actions">
                                    <a className="heroItmex-cta" href="#comunidades">
                                        Ver comunidades
                                        <span className="heroItmex-cta-arrow"><i className="fas fa-arrow-down"></i></span>
                                    </a>
                                    <a className="heroItmex-cta-secondary" href={WHATSAPP_COBERTURA} target="_blank" rel="noopener noreferrer">
                                        <i className="fab fa-whatsapp mr-2"></i> Preguntar por WhatsApp
                                    </a>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="coberturaLista" id="comunidades">
                        <div className="planesItmex-header">
                            <h2 className="tituloItmex tituloItmex--chico">Tenemos presencia en</h2>
                            <p className="planesItmex-subtitulo">Busca tu comunidad o abre tu municipio para ver dónde llega el servicio.</p>
                        </div>

                        <div className="coberturaBuscador">
                            <i className="fas fa-search"></i>
                            <input
                                type="search"
                                placeholder="Busca tu comunidad o municipio"
                                aria-label="Buscar comunidad o municipio"
                                value={this.state.busqueda}
                                onChange={e => this.setState({ busqueda: e.target.value })}
                            />
                        </div>
                        <div className="coberturaLeyenda">
                            <ChipTecnologia tipo="fibra" />
                            <ChipTecnologia tipo="inalambrico" />
                            <ChipTecnologia tipo="nuevo" />
                        </div>

                        {this.state.loading ? (
                            <div className="coberturaCargando"><span className="spinner-border spinner-border-sm mr-2"></span>Cargando comunidades…</div>
                        ) : (
                            estados.map(estado => (
                                <div className="coberturaEstado" key={estado.id}>
                                    <h3 className="coberturaEstado-titulo"><i className="fas fa-map-marker-alt"></i>{estado.estado}</h3>
                                    <div className="coberturaEstado-municipios">
                                        {estado.municipioszonas.map(this.renderMunicipio)}
                                    </div>
                                </div>
                            ))
                        )}

                        {sinResultados && (
                            <p className="coberturaSinResultados">No encontramos “{this.state.busqueda}”. Escríbenos y revisamos la disponibilidad en tu zona.</p>
                        )}

                        <aside className="planesItmex-panel coberturaPanel">
                            <span className="planesItmex-eyebrow">Disponibilidad</span>
                            <h3 className="planesItmex-panel-titulo">¿No encuentras tu comunidad?</h3>
                            <p>Contáctanos y revisamos la disponibilidad del servicio en tu zona o domicilio.</p>
                            <div className="planesItmex-panel-acciones">
                                <Link className="heroItmex-cta planesItmex-panel-cta" to="/contacto">
                                    Contáctanos
                                    <span className="heroItmex-cta-arrow"><i className="fas fa-arrow-right"></i></span>
                                </Link>
                                <a className="planesItmex-panel-whatsapp" href={WHATSAPP_COBERTURA} target="_blank" rel="noopener noreferrer">
                                    <i className="fab fa-whatsapp"></i> WhatsApp
                                </a>
                            </div>
                        </aside>
                    </section>
                </Layout>
            </div>
        )
    }
};
export default Cobertura;
